module.exports = __webpack_public_path__ + "img/share.67539d8f.svg";